import YouTube from 'react-youtube'
import React, { Component } from 'react'

import { px2Rem } from '../../../themes/Mixins'
import COLORS from '../../../themes/Colors'
import ICONS from '../../../themes/Icon'

import Modal from '../../common/Modal'

export default class VideoPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      height: 0,
      player: null
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isShowVideoPopup !== this.props.isShowVideoPopup) {
      if (nextProps.isShowVideoPopup) {
        this.modalPopup.style.display = 'flex'
        this.state.player && this.state.player.playVideo()
      } else {
        this.state.player && this.state.player.pauseVideo()
        this.modalPopup.style.display = 'none'
      }
    }
  }

  changeSizeVideoPopup = () => {
    const windowGlobal = typeof window !== 'undefined' && window
    let width = windowGlobal.innerWidth
    let height = width / 1.777777778
    if (windowGlobal.innerHeight < (windowGlobal.innerWidth / 1.777777778)) {
      height = windowGlobal.innerHeight
      width = height * 1.777777778
    }

    this.setState({
      width: width,
      height: height
    })
  }

  componentWillMount() {
    this.changeSizeVideoPopup();
  }

  componentDidMount() {
    window.addEventListener('resize', this.changeSizeVideoPopup, false)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.changeSizeVideoPopup, false)
  }

  onReady = (event) => {
    this.setState({
      player: event.target
    })
  }

  render() {
    const { handleShowVideoPopup } = this.props
    const { width, height } = this.state
    const videoId = 'q_ZWrAtM6lk'

    return (
      <Modal
        modalRef={ref => this.modalPopup = ref}
        onToggleModal={() => handleShowVideoPopup()}
        backdropStyle={{
          backgroundColor: `${COLORS.bgVideoPopup}`,
          width: '100%',
          height: '100%',
          display: 'none',
          alignItems: 'center'
        }}
        styleBtnClose={{
          background: `transparent url(${ICONS.closeWhite}) no-repeat`
        }}
        style={{
          width: `${px2Rem(width)}`,
          height: `${px2Rem(height)}`,
          padding: '0',
          backgroundColor: 'transparent'
        }}
        hideCloseIcon
      >
        <YouTube
          videoId={videoId}
          onReady={this.onReady}
          opts={{
            height: '100%',
            width: '100%',
            playerVars: {
              showinfo: '0',
              rel: '0',
              loop: '1',
              vq: 'hd1080',
              playlist: videoId
            }
          }}
        />
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/video-popup/VideoPopup.js